import TablaConciliacion from "../../../TablaConciliacion";

function TablaSabanaOcc() {
  return <TablaConciliacion nombreUseCase="SABANAOCC" titulo="SABANA OCCIDENTE" />;
}

export default TablaSabanaOcc;
